var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg"},[_vm._t("default"),_vm._v(" "),_c('v-card-text',{staticClass:"pb-0 pt-5"},[_vm._t("content")],2),_vm._v(" "),_c('v-card-actions',{staticClass:"px-6 pb-5 pt-0"},[_vm._t("actions")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }